import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {AppSettingsStore} from "../../store/app-settings.store";
import {ThemeService} from "../../shared/service/theme.service";

/**
 * Icon button switching between the light and dark theme
 */
@Component({
  selector: 'app-theme-toggle',
  imports: [
    MatIconButton,
    MatIcon,
    TranslateModule
  ],
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThemeToggleComponent {
  private readonly themeService = inject(ThemeService);

  readonly darkTheme = inject(AppSettingsStore).darkTheme;

  toggle() {
    this.themeService.toggleDarkTheme(!this.darkTheme());
  }
}
